import React from 'react'
import { SegmentMetadata } from '@zocks-communications/client-sdk-js'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult, SegmentedResult } from '../../../../../../../models/AiResult'
import { StructuredSummaryMeetingResultView } from './StructuredSummaryMeetingResultView'
import { useAppSelector } from '../../../../../../../store/hooks'
import { selectRoomSessionStartedAt } from '../../../../../../../store/meetingSummary/roomSession'
import { getResultSegmentHeader } from '../../../utils'

interface SegmentedMeetingResultViewProps {
  aiFeature: AiFeature
  aiResult: AiResult
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const SegmentedMeetingResultView: React.FC<SegmentedMeetingResultViewProps> = ({ aiFeature, aiResult, onFormattedResultChange }) => {
  const result = aiResult.result as SegmentedResult

  const { segmentResults } = result

  const segmentCount =
    Math.max(
      ...segmentResults.map((segmentResult) => {
        return segmentResult.metadata.segmentIdx
      }),
    ) + 1

  return (
    <div className='d-flex flex-column gap-3'>
      {segmentResults.map((segmentResult, segmentIdx) => {
        const { results, metadata } = segmentResult
        return (
          <div key={segmentIdx} className='d-flex flex-column'>
            <SegmentedResultHeader segmentCount={segmentCount} metadata={metadata} />
            {results.map((result, resultIdx) => {
              if (result.type !== 'structuredSummary') {
                return null
              }
              const basePath = `$.segmentResults[${segmentIdx}]["results"][${resultIdx}]`
              const resultPath = '$.result'
              return (
                <StructuredSummaryMeetingResultView
                  key={basePath}
                  aiResult={aiResult}
                  aiFeature={aiFeature}
                  basePath={basePath}
                  path={resultPath}
                  onFormattedResultChange={onFormattedResultChange}
                />
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
export const SegmentedResultHeader: React.FC<{
  metadata: SegmentMetadata
  segmentCount: number
}> = ({ metadata, segmentCount }) => {
  const roomSessionStartedAt = useAppSelector(selectRoomSessionStartedAt)

  return (
    <div className='d-flex justify-content-between paragraph-medium pe-4 ps-2 pb-1'>
      <div>{getResultSegmentHeader(metadata, roomSessionStartedAt)}</div>
      <div className='text-capitalize'>
        Segment: {metadata.segmentIdx + 1} / {segmentCount}
      </div>
    </div>
  )
}
